import { RootState } from 'editor/src/store/index';

// Optional chaining because the page operations also run in stores built without host settings,
// which keep the rules they had.
function isPageCountOptionsEnabled(state: RootState): boolean {
  return !!state.hostSettings?.enablePageCountOptions;
}

export default isPageCountOptionsEnabled;
